import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LsqCoreModule } from '@lsq-frontend/common-ui';
import { ScrollbarModule } from 'ngx-scrollbar';
import { NotificationComponent } from './notification.component';
import { NotificationsComponent } from './notifications.component';

@NgModule({
    imports: [CommonModule, LsqCoreModule.forChild(), ScrollbarModule],
    declarations: [NotificationsComponent, NotificationComponent],
    exports: [NotificationsComponent, NotificationComponent]
})
export class NotificationsModule {}
